<script setup>
import { ref, onMounted } from 'vue';
import FooterSection from './layout/FooterSection.vue';
// import NavBar from './layout/NavBar.vue';

// Define loading state
const loading = ref(true);

onMounted(() => {
  setTimeout(() => {
    loading.value = false;
  }, 3000);
});
</script>

<template>
  <div>
    <div>
      <!-- <NavBar /> -->
      <RouterView />
      <FooterSection />
    </div>
  </div>
</template>

<style scoped>
</style>
